'use client';

import { CheckCircle, Zap, Shield, Cog } from 'lucide-react';
import { motion } from 'framer-motion';

const features = [
  {
    name: 'Quality Assurance',
    description: 'Our harnesses undergo rigorous testing to ensure top-notch performance.',
    icon: CheckCircle,
  },
  {
    name: 'Custom Solutions',
    description: 'Tailored harness designs to meet your specific requirements.',
    icon: Zap,
  },
  {
    name: 'Reliability',
    description: 'Built to withstand harsh environments and ensure long-lasting operation.',
    icon: Shield,
  },
  {
    name: 'Advanced Technology',
    description: 'Incorporating the latest innovations in electrical harness manufacturing.',
    icon: Cog,
  },
];

export default function Features() {
  return (
    <section className="py-8 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="mt-2 text-4xl font-extrabold text-gray-900">
            Why Choose Our Electrical Harnesses
          </p>
          <p className="mt-4 text-xl text-gray-600 max-w-2xl mx-auto">
            Designed for performance, reliability, and flexibility, our harnesses are built to exceed expectations.
          </p>
        </div>

        <div className="grid gap-10 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              viewport={{ once: true }}
              className="bg-gray-50 p-6 rounded-xl shadow hover:shadow-md transition"
            >
              <div className="flex items-center justify-center mb-4 h-12 w-12 rounded-full bg-orange-100">
                <feature.icon className="h-6 w-6 text-orange-500" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{feature.name}</h3>
              <p className="text-sm text-gray-600">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
